const geoDataConstants = {
	FETCH_GEODATA_REQUEST: 'FETCH_GEODATA_REQUEST',
	FETCH_GEODATA_SUCCESS: 'FETCH_GEODATA_SUCCESS',
	FETCH_GEODATA_FAILURE: 'FETCH_GEODATA_FAILURE',
};
export default geoDataConstants;
